import {
  OrganizationEntityArg,
  OrganizationEntityArgType
} from './organization-entities-arg'

export interface SingularOrganizationEntityMutationArgs {
  readonly input: OrganizationEntityArg
}

export const singularOrganizationEntityMutationArgs = {
  input: {
    type: OrganizationEntityArgType
  }
}
